module.exports = __webpack_public_path__ + "static/media/Resource1.dbaf7f3a.webp";